export const ACCREDITATION_GRID_SORT_ENABLED = 'ACCREDITATION_GRID_SORT_ENABLED'
export const ACCREDITATION_GRID_SORT_DISABLED = 'ACCREDITATION_GRID_SORT_DISABLED'
export const ACCREDITATION_GRID_SORT_UPDATED = 'updated'

function enable(sortField) {
  return {
    type: ACCREDITATION_GRID_SORT_ENABLED,
    sortField,
  }
}

function disable() {
  return {
    type: ACCREDITATION_GRID_SORT_DISABLED,
    sortField: null,
  }
}

export function enableAccreditationSort(sortField) {
  return (dispatch) => {
    dispatch(enable(sortField))
  }
}

export function disableAccreditationSort() {
  return (dispatch) => {
    dispatch(disable())
  }
}
